import styled from "styled-components";

// import { Default } from "Types";

import OrganismSuccess from "Components/Organisms/Success";
import { typography } from "globalConstants";

export type PropsType = any;

const Wrap = styled.div`
   display: flex;
   flex-direction: column;
   align-items: center;
`;
const Buttons = styled.div`
   display: flex;
   flex-direction: row;
   column-gap: 41px;
`;
const Button = styled.a`
   ${typography.other.t4}
   display: block;
   line-height: 40px;
   text-align: center;
   margin-top: 35px;
   background-color: ${typography.other.color.purple[0]};
   border: none;
   outline: none;
   color: white !important;
   width: 169px;
   max-width: 100%;
   height: 41px;
   border-radius: 4px;
   transition-duration: 100ms;
   transition-property: opacity;
   transition-timing-function: ease-in-out;
   box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.25);
   &:active {
      opacity: 0.8;
   }
`;
const BarLine = styled.div`
   width: 100%;
   height: 21px;
   background-color: ${typography.other.color.purple[0]};
`;

export default function TemplateSuccess(props: PropsType) {
   return (
      <Wrap>
         <BarLine></BarLine>
         <OrganismSuccess></OrganismSuccess>
         <Buttons>
            <Button href="https://art-map.co.kr/download_pp.php">상품소개서 다운받기</Button>
            <Button href="https://art-map.co.kr/estimate" target="_blank">
               견적 미리보기
            </Button>
         </Buttons>
      </Wrap>
   );
}
